import RootDevice from "./RootDevice.js";
import RootDeviceGroup from "./RootDeviceGroup.js";
import RootDeviceType from "./RootDeviceType.js";
import RootFirmwareApplication from "./RootFirmwareApplication.js";
import RootFirmwareComponent from "./RootFirmwareComponent.js";
import RootFirmwareRelease from "./RootFirmwareRelease.js";
import { install } from "./PluginSetup.js";
export default {
  RootDevice,
  RootDeviceGroup,
  RootDeviceType,
  RootFirmwareApplication,
  RootFirmwareRelease,
  RootFirmwareComponent,
  install
};